// Tenant-scoped path builder for the Messages routes. The app lives under
// /t/<slug>/app/..., so navigating with a bare '/messages/:id' falls through to the
// dashboard — always build the full tenant path.
import { useLocation } from 'react-router-dom';
import { buildTenantPath, extractTenantSlug } from '@/features/navigation/utils';

export function useMessagesRoute(): (conversationId?: string) => string {
  const location = useLocation();
  const slug = extractTenantSlug(location.pathname);
  return (conversationId?: string) =>
    buildTenantPath(conversationId ? `messages/${conversationId}` : 'messages', slug);
}
